import React from 'react';

import style from './index.scss';

export default ({
    className = '',
    gameInfoPath = '/'
}) => (
    <a href={gameInfoPath} className={`fn-redirect ${style.icon} ${className}`} />
);
